import type { FormLocale } from '@jlg-website/shared';
import { PeriodTabItem } from './period-tab-item';
import { TimeSlotItem } from './time-slot-item';
import { StepBackButton } from '../shared/step-back-button';
import { formatDayLabel } from '../shared/date-time';
import { slotPeriods } from './constants';
import { textFor } from '../shared/copy';
import type { CallbackSlot, SlotPeriod } from './type';

type TimeStepProps = {
  date: string;
  slots: CallbackSlot[];
  period: SlotPeriod;
  selectedSlot: CallbackSlot | null;
  locale: FormLocale;
  onSelectPeriod: (period: SlotPeriod) => void;
  onSelectSlot: (slot: CallbackSlot) => void;
  onBack: () => void;
};

export function TimeStep({
  date,
  slots,
  period,
  selectedSlot,
  locale,
  onSelectPeriod,
  onSelectSlot,
  onBack,
}: TimeStepProps) {
  const periodSlots = slots.filter((slot) => slot.period === period);

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center gap-3">
        <StepBackButton onClick={onBack} label={textFor(locale, 'backToCalendar')} />
        <p className="text-sm font-bold text-brand-text-button">
          {textFor(locale, 'availableTimes')}{' '}
          <span className="font-normal text-gray-light">· {formatDayLabel(locale, date)}</span>
        </p>
      </div>

      <div className="flex gap-2">
        {slotPeriods.map((option) => (
          <PeriodTabItem
            key={option}
            period={option}
            selected={option === period}
            disabled={!slots.some((slot) => slot.period === option)}
            locale={locale}
            onSelect={onSelectPeriod}
          />
        ))}
      </div>

      {periodSlots.length === 0 ? (
        <p className="py-8 text-center text-sm text-gray-light">{textFor(locale, 'noTimesLeft')}</p>
      ) : (
        <div className="grid grid-cols-3 gap-2">
          {periodSlots.map((slot) => (
            <TimeSlotItem
              key={slot.startsAt}
              slot={slot}
              selected={slot.startsAt === selectedSlot?.startsAt}
              onSelect={onSelectSlot}
            />
          ))}
        </div>
      )}
    </div>
  );
}
